<title>{{ iagPortalHowDoIMakeABookingPage.htmlTitle }}</title>
<div class="" id="iagPortalHowDoIMakeABookingPage">
  <div id="makkingBooking">
    <app-section [sections]="iagPortalHowDoIMakeABookingPage.makingBookingSection" [isIAGPortalDocumentationPage]="true"></app-section>
  </div>
  <div id="shopping">
    <app-section [sections]="iagPortalHowDoIMakeABookingPage.shoppingSearchSection" [isIAGPortalDocumentationPage]="true"></app-section>
    <app-section [sections]="iagPortalHowDoIMakeABookingPage.fareTypesSection" [isIAGPortalDocumentationPage]="true"> </app-section>
  </div>
  <div id="offers">
    <app-section [sections]="iagPortalHowDoIMakeABookingPage.offersSection" [isIAGPortalDocumentationPage]="true"> </app-section>
  </div>
  <div id="details">
    <app-section [sections]="iagPortalHowDoIMakeABookingPage.detailsSection" [isIAGPortalDocumentationPage]="true"> </app-section>
  </div>
  <div style="padding: 0; margin: 0">
    <app-iag-portal-accordian-section [accordianSections]="iagPortalHowDoIMakeABookingPage.expandImageSection"> </app-iag-portal-accordian-section>
  </div>
</div>
